import { Stack } from '@mui/material';
import { type ComponentType } from 'react';

import { api, isDefined } from 'common';

import { CreateAuthorizationSubmissionsFormFields } from './FormFields/authorizationSubmissionsFormFields';
import { CreateEncounterFormFields } from './FormFields/encounterFormFields';
import { CreatePatientFormFields } from './FormFields/patientFormFields';
import { CreateServiceReviewSubmissionsFormFields } from './FormFields/serviceReviewSubmissionsFormFields';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { useSelectedNodeField } from '../../ConfigFields/useSelectedNodeField';

const NotableObject = api.FlowDefinition.NotableObject;
type NotableObject = api.FlowDefinition.NotableObject;

const CREATE_NOTABLE_OBJECT_FORM_FIELDS: Partial<Record<NotableObject, ComponentType>> = {
  [NotableObject.Encounter]: CreateEncounterFormFields,
  [NotableObject.Patient]: CreatePatientFormFields,
  [NotableObject.ServiceReviewSubmissions]: CreateServiceReviewSubmissionsFormFields,
  [NotableObject.AuthorizationSubmissions]: CreateAuthorizationSubmissionsFormFields,
};

export function CreateNotableObjectFormFields() {
  const { value: notableObject } =
    useSelectedNodeField<api.FlowDefinition.CreateNotableObjectConfig['notableObject']>(
      'config.notableObject'
    );
  const FormFields = isDefined(notableObject)
    ? CREATE_NOTABLE_OBJECT_FORM_FIELDS[notableObject]
    : undefined;
  return (
    <Stack gap={3}>
      <BlockSelectField
        label="Notable Object"
        fieldName="config.notableObject"
        required
        options={Object.keys(CREATE_NOTABLE_OBJECT_FORM_FIELDS).map((notableObject) => ({
          label: notableObject,
          value: notableObject,
        }))}
      />
      {isDefined(FormFields) && <FormFields />}
    </Stack>
  );
}
